import React from 'react';
import EmailClient from './EmailClient';
import { FakeWrapper } from '../../../layout';
import { emailClients } from '../emailDomains';

const EmailClientsModal = () => {
  return (
    <FakeWrapper
      title="Select your email provider"
      ctaId="set-up-profile-continue-btn"
    >
      {emailClients.map((client) => {
        return (
          <EmailClient
            name={client.name}
            redirectUrl={client.url}
            imageUrl={client.imageUrl}
            trackingEvent={client.trackingEvent}
          />
        );
      })}
    </FakeWrapper>
  );
};

export default EmailClientsModal;
